module.exports = __webpack_public_path__ + "static/media/health_main@2x.4791a5c7.png";